import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from './../actions/user_actions';
import * as SettingActions from './../actions/settingScreen_actions';
import { ModalDialogCommon } from './modal_dialog_common';
import { bindActionCreators } from 'redux';
import { validate } from '../validations';
import { Loader } from './loader';

// start - Login Header Component
let LoginHeaderComponent = React.createClass({
    render() {
        return (<div className="vertalign-container"><div className="container main vertalign-child"><h1 className="top-logo">mobi</h1><div className="admin-login security security-ques"> {this.props.children}</div></div></div>)
    }
});
// End - Login Header Component

// start - Security Questions Component
let QuestionsComponent = React.createClass({
    getInitialState() {
        return {
        }
    },

    render() {

        return (<div>
            <p className="login-head"> <span className="icon-backarrow" onClick={this.props.back}></span>You are almost there.</p>
            {this.props.questionsLength ? <p className="reset-text">Please answer the below questions to proceed further.</p> : <p className="reset-text">No question to display. Please contact your admin.</p>}
            {this.props.questions}
            {this.props.errorMessage && <div className="error-message">
                <span className="red-color">{this.props.errorMessage} </span>
            </div>}
            <div className="reset-button">
                {this.props.questionsLength > 0 && <button className="gray-button" onClick={this.props.submitAnswer}>NEXT</button>}
            </div>
        </div>
        )
    }
});
// end - Security Questions Component

// start - ResetPassword Component
let ResetPassword = React.createClass({
    getInitialState() {
        return {
            questionList: [],
            token: '', // Auth token, Taken from ResetPassword URL
            isAnswersSubmitted: false,
            okModalMsg: null,
            errorMessage: null,
            showLoader: null,
            confimationModalMessage: null,
        }
    },
    componentWillMount() {
        this.props.router.push('/newpassword?id=' + this.state.token[1] + "&?k=" + this.state.token[0])

        // redirection to login page, if another user session already exists.
        // if (this.props.LoggedInUser && this.props.LoggedInUser.loginData && this.props.LoggedInUser.loginData.status === 200) {

        //     this.setState({ confimationModalMessage: 'You need to logout the current session to register a new account.' });
        //     return;
        // }

        // this.getUserInfo();
    },
    getUserInfo() {
        // ResetPassword URL parsing.
        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
        var token = getParameterByName('token', window.location.href);
        var data = token.split('#')

        this.setState({ token: data });
        this.setState({ showLoader: true });
        //this.props.Dispatch(UserActions.getSecurityQuestion(data[1]));
        this.props.Dispatch(SettingActions.getAllRandomSecurityQuestionsById(data[1]));

    },
    onConfirmed() {
         this.props.Dispatch(UserActions.logout(
            {
                "appType": "WEB",
                "id":this.props.LoggedInUser.loginData.data.id
            }
        ));

        this.setState({ confimationModalMessage: null });
    },
    closeConfirmationModal() {
        this.setState({ confimationModalMessage: null });
        this.props.router.push('/');
    },
    componentWillReceiveProps(nextProps) {

        if (nextProps.Setting.allRandomSecurityQuestions) {

            if (nextProps.Setting.allRandomSecurityQuestions.status == 200 && nextProps.Setting.allRandomSecurityQuestions.data) {
                var randomQuestions = [];

                for (let key in nextProps.Setting.allRandomSecurityQuestions.data) {
                    if (nextProps.Setting.allRandomSecurityQuestions.data.hasOwnProperty(key)) {

                        var data = {
                            'id': key,
                            'name': nextProps.Setting.allRandomSecurityQuestions.data[key]
                        }
                        randomQuestions.push(data)
                    }
                }
                this.setState({ questionList: randomQuestions });
                this.setState({ showLoader: false });
            }
            else {
                this.setState({ showLoader: false });
            }
        }

        if (this.state.isAnswersSubmitted) {
            this.setState({ isAnswersSubmitted: null });
            if (nextProps.verification.status == 200) {
                this.props.router.push('/newpassword?id=' + this.state.token[1] + "&?k=" + this.state.token[0])
            }
            else {
                this.setState({ okModalMsg: nextProps.verification.message });
            }
        }

        if (nextProps.SessionLogoutResponse) {
            if (nextProps.SessionLogoutResponse.status == 200) {
                this.props.Dispatch(UserActions.user_log_out());
                localStorage.clear();
                this.getUserInfo();
            } else {
                // need to show error msg from server response
            }
        }
    },
    componentDidMount() {

    },
    remove_error(event) {
        event.target.className = 'update-mail';
    },
    no_empty(event) {
        event.target.value.trim().length > 0 ? event.target.parentElement.className = 'input-b-border' : event.target.parentElement.className = 'input-b-border error-border-bottom';
    },

    sendBack() {
        this.props.router.push('/');
    },
    generateQuestions: function () {
        var questionList = this.state.questionList;
        var list = questionList.map(function (question, key) {
            return (
                <div className="btn-group question-select" key={key}>
                    <div className="gray-dropdown">
                        <p className="reset-questions">{question.name}</p>
                    </div>
                    <div className="input-b-border" >
                        <input className="update-mail" onBlur={this.no_empty} onFocus={this.remove_error} placeholder="Type your answer" type="text" ref={"Answer" + key} data-id={question.id} />
                    </div>
                </div>
            )
        }, this);

        // if (!list.length) {
        //     return {
        //         question: (<div className="btn-group question-select"> <p className="error">No security questions found. </p></div>),
        //         questionFlag: false
        //     };
        // } else {
        return {
            question: list,
            questionFlag: list.length
        };
        //}
    },
    submitAnswer: function () {
        let isValidAnswers = true;
        this.state.questionList.map(function (item, i) {
            this.refs['Answer' + i].value.trim().length > 0 ? this.refs['Answer' + i].parentElement.className = 'input-b-border' : this.refs['Answer' + i].parentElement.className = 'input-b-border error-border-bottom';
            if (this.refs['Answer' + i].value.trim().length === 0) {
                isValidAnswers = false;
            }
        }.bind(this));

        if (!isValidAnswers) {
            this.setState({
                errorMessage: "Please enter valid information."
            });
        }
        else {
            var data = {};
            data.id = this.state.token[1];
            data.uniqueKey = this.state.token[0];
            data.sequrityAnswer = [];
            this.state.questionList.map(function (item, i) {
                data.sequrityAnswer.push({
                    "answer": this.refs['Answer' + i].value, "question": { "id": this.refs['Answer' + i].attributes['data-id'].value }
                })
                return data.sequrityAnswer;
            }.bind(this));
            this.setState({
                isAnswersSubmitted: true,
                errorMessage: null,
            })
            this.props.Dispatch(UserActions.verifySecurityQuestions(data));
        }
    },

    closeBoxOnScuess() {
        this.setState({ okModalMsg: null });
    },

    render() {
   
        return (
            <div>
                <LoginHeaderComponent >
                    <QuestionsComponent questions={this.generateQuestions().question} questionsLength={this.generateQuestions().questionFlag} submitAnswer={this.submitAnswer} back={this.sendBack} errorMessage={this.state.errorMessage} />
                    {this.state.okModalMsg && <ModalDialogCommon message={this.state.okModalMsg} action={this.closeBoxOnScuess} />}
                    {this.state.showLoader && <Loader />}
                </LoginHeaderComponent >
                {this.state.confimationModalMessage && <ModalDialogCommon message={this.state.confimationModalMessage} cancel="true" action2={this.closeConfirmationModal} action={this.onConfirmed} />}
            </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        LoggedInUser: state.User,
        verification: state.User.verificationResponse,
        Setting: state.Setting,
        SessionLogoutResponse: state.User.sessionLogoutResponse,
    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(ResetPassword));
// End - ResetPassword Componen



/** WEBPACK FOOTER **
 ** ./src/components/resetpassword.js
 **/